import React, { useRef } from "react";
import { Box, Typography } from "@mzc-pdc/ui";
import Tooltip from "@components_v2/Tooltip/tooltip";
import useTextOverflow from "@hooks/useTextOverflow";

/**
 * EllipsisTooltip - 텍스트가 지정된 너비를 초과하여 ellipsis 처리될 때 툴팁을 표시하는 컴포넌트
 *
 * @param {number} lineClamp 말줄임 전까지 허용할 줄 수. 기본 1줄이며 2 이상이면 줄바꿈 후 해당 줄에서 말줄임 처리
 */
const EllipsisTooltip = ({
    text,
    maxWidth,
    sx = {},
    variant = "body2",
    placement = "bottom",
    lineClamp = 1,
    typographyProps = {},
    boxProps = {},
    ...otherProps
}) => {
    const textRef = useRef(null);
    const isEllipsed = useTextOverflow(textRef, [text, lineClamp]);

    const clampSx =
        lineClamp > 1
            ? {
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: lineClamp,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
              }
            : {
                  display: "block",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
              };

    return (
        <Box
            sx={{
                ...sx,
                maxWidth: maxWidth,
            }}
            {...boxProps}
        >
            <Tooltip title={isEllipsed ? text : ""} placement={placement} {...otherProps}>
                <Typography
                    ref={textRef}
                    variant={variant}
                    {...typographyProps}
                    sx={{
                        overflow: "hidden",
                        width: "100%",
                        ...clampSx,
                        ...typographyProps.sx,
                    }}
                >
                    {text}
                </Typography>
            </Tooltip>
        </Box>
    );
};

export default EllipsisTooltip;
